import React from "react"
import { b2cPolicies } from "./AuthConfig"
import Loader from "../Components/Shared/Loader/loader"
import { Navigate } from 'react-router-dom'
import { useMsal } from "@azure/msal-react"

const SignIn = () => {

    const context = useMsal()

    const urlParams = new URLSearchParams(window.location.search);

    // get urlparams selectedOrganization from url
    let selectedOrganization = urlParams.get('selectedOrganization');
    
    // store selectedOrganization if defined in local storage else remove item from local storage
    if (selectedOrganization) {
        localStorage.setItem("selectedOrganizationId", selectedOrganization);
    } else {
        localStorage.removeItem("selectedOrganizationId");
    }

    if (context.inProgress !== "none") {
        return <Loader />
    }

    if (context.accounts.length === 0) {
        context.instance.loginRedirect(b2cPolicies.authorities.signUpSignIn)
        return <></>
    } else {
        return (
            <Navigate to="/" />
        )
    }
}

export default SignIn
